export const INTEGRATION_SUBSCRIBE_TO_HISTORY = Symbol('INTEGRATION_SUBSCRIBE_TO_HISTORY');
export const INTEGRATION_LAYOUT_CHANGED = Symbol('INTEGRATION_LAYOUT_CHANGED');
export const WINDOW_RESIZED = Symbol('WINDOW_RESIZED');

/**
 * @return {{type: symbol, payload: *}}
 */
export const integrationSubscribedToHistoryAction = () => ({
  type: INTEGRATION_SUBSCRIBE_TO_HISTORY,
});

/**
 *
 * @param {string} layout
 * @param {string} portalUrl
 * @return {{type: symbol, payload: {}}}
 */
export const integrationLayoutChangedAction = (layout, portalUrl) => ({
  type: INTEGRATION_LAYOUT_CHANGED,
  payload: { layout, portalUrl },
});

/**
 * @param {number} size
 * @param {string} range
 * @param {bool} isDevice
 * @returns {{type: symbol, payload: {size: *, range: *, isDevice: *}}}
 */
export const resizeWindowAction = ({ size, range, isDevice }) => ({
  type: WINDOW_RESIZED,
  payload: { size, range, isDevice },
});
